import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import AsyncSelect from "react-select/async";
import getAxiosInstance from "./../../Utils/axios";
import {
  getCountries,
  getStates,
  getCities,
  getBuildings,
  getFloors,
  getIdList,
} from "./../../Utils/api";
import AddUpdateScreen from "../../Components/AddUpdateScreen";
import AddScheduleCampaign from "../../Components/AddScheduleCampaign";
import AddScreenCsv from "../../Components/AddScreenCsv";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

export default function Screen() {
  const [screens, setScreens] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [notAdmin, setNotAdmin] = useState(false);
  const [searchFilter, setSearchFilter] = useState("");
  const [limit, setLimit] = useState(20);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalScreens, setTotalScreens] = useState(0);

  const [selectionType, setSelectionType] = useState("");
  const [selectedScreen, setSelectedScreen] = useState([]);

  // Location
  const [country, setCountry] = useState([]);
  const [inputCountry, setInputCountry] = useState("");
  const [state, setState] = useState([]);
  const [inputState, setInputState] = useState("");
  const [city, setCity] = useState([]);
  const [inputCity, setInputCity] = useState("");
  const [building, setBuilding] = useState([]);
  const [inputBuilding, setInputBuilding] = useState("");
  const [floor, setFloor] = useState([]);
  const [inputFloor, setInputFloor] = useState("");

  //   dropdown options
  const [countryOpt, setCountryOpt] = useState("");
  const [allCountry, setAllCountry] = useState([]);

  const [stateOpt, setStateOpt] = useState("");
  const [allState, setAllState] = useState([]);

  const [cityOpt, setCityOpt] = useState("");
  const [allCity, setAllCity] = useState([]);

  const [buildingOpt, setBuildingOPt] = useState("");
  const [allBuilding, setAllBuilding] = useState([]);

  const [floorOpt, setFloorOpt] = useState("");
  const [allFloor, setAllFloor] = useState([]);
  const { type, media } = useParams();

  const fetchCountryData = (inputValue) => getCountries(inputValue);
  const fetchStateData = (inputValue) =>
    getStates(inputValue, getIdList(country));
  const fetchCityData = (inputValue) =>
    getCities(inputValue, getIdList(country), getIdList(state));
  const fetchBuildingData = (inputValue) =>
    getBuildings(
      inputValue,
      getIdList(country),
      getIdList(state),
      getIdList(city)
    );
  const fetchFloorData = (inputValue) =>
    getFloors(
      inputValue,
      getIdList(country),
      getIdList(state),
      getIdList(city),
      getIdList(building)
    );

  // Use refs to store the latest values for the interval
  const latestValuesRef = useRef({
    limit,
    pageNumber,
    searchFilter,
    countryOpt,
    stateOpt,
    cityOpt,
    buildingOpt,
    floorOpt,
  });

  // Update ref whenever values change
  useEffect(() => {
    latestValuesRef.current = {
      limit,
      pageNumber,
      searchFilter,
      countryOpt,
      stateOpt,
      cityOpt,
      buildingOpt,
      floorOpt,
    };
  }, [
    limit,
    pageNumber,
    searchFilter,
    countryOpt,
    stateOpt,
    cityOpt,
    buildingOpt,
    floorOpt,
  ]);

  // Reset selection when filters change
  useEffect(() => {
    setSelectionType("");
    setSelectedScreen([]);
  }, [
    countryOpt,
    stateOpt,
    cityOpt,
    buildingOpt,
    floorOpt,
    searchFilter,
    limit,
    pageNumber,
  ]);

  // ----------

  // get country option
  useEffect(() => {
    const params = {};
    getAxiosInstance()
      .post("/admin/countries", params, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
      .then((res) => {
        console.log(res.data.result);
        setAllCountry(res.data.result);
      })
      .catch((err) => console.log(err));
  }, []);

  // get states option
  useEffect(() => {
    if (!countryOpt) {
      setAllState([]);
      return;
    }
    let formdata = new FormData();
    //add three variable to form
    formdata.append("country", country);
    console.log({ inputCountry });
    // const data = JSON.parse(country);
    getAxiosInstance()
      .post(
        "/admin/states",
        { country: countryOpt }
        // {
        //   headers: { "Content-Type": "application/x-www-form-urlencoded" },
        // }
      )
      .then((res) => {
        console.log(res.data.result);
        setAllState(res.data.result);
      })
      .catch((err) => console.log(err));
  }, [countryOpt]);

  // get cities option
  useEffect(() => {
    if (!stateOpt) {
      setAllCity([]);
      return;
    }
    // let formdata = new FormData();
    // formdata.append("state", stateOpt);
    getAxiosInstance()
      .post(
        "/admin/cities",
        { state: stateOpt }
        // {
        //   headers: { "Content-Type": "application/json" },
        // }
      )
      .then((res) => {
        console.log(res.data.result);
        setAllCity(res.data.result);
      })
      .catch((err) => console.log(err));
  }, [stateOpt]);

  // get buildings option
  useEffect(() => {
    if (!cityOpt) {
      setAllBuilding([]);
      return;
    }
    // let formdata = new FormData();
    // formdata.append("state", stateOpt);
    getAxiosInstance()
      .post(
        "/admin/buildings",
        { city: cityOpt }
        // {
        //   headers: { "Content-Type": "application/json" },
        // }
      )
      .then((res) => {
        console.log(res.data.result);
        setAllBuilding(res.data.result);
      })
      .catch((err) => console.log(err));
  }, [cityOpt]);

  // get floor options
  useEffect(() => {
    if (!buildingOpt) {
      setAllFloor([]);
      return;
    }
    // let formdata = new FormData();
    // formdata.append("state", stateOpt);
    getAxiosInstance()
      .post(
        "/admin/floors",
        { building: buildingOpt }
        // {
        //   headers: { "Content-Type": "application/json" },
        // }
      )
      .then((res) => {
        console.log(res.data.result);
        setAllFloor(res.data.result);
      })
      .catch((err) => console.log(err));
  }, [buildingOpt]);

  const getScreens = (useLatestValues = false) => {
    const values = useLatestValues
      ? latestValuesRef.current
      : {
          limit,
          pageNumber,
          searchFilter,
          countryOpt,
          stateOpt,
          cityOpt,
          buildingOpt,
          floorOpt,
        };

    let jsonData = {
      limit: values.limit,
      page: values.pageNumber * values.limit,
      search: values.searchFilter,
      //   country: getIdList(country),
      //   state: getIdList(state),
      //   city: getIdList(city),
      //   building: getIdList(building),
      //   floor: getIdList(floor),
      country: values.countryOpt,
      state: values.stateOpt,
      city: values.cityOpt,
      building: values.buildingOpt,
      floor: values.floorOpt,
    };
    // converting (json --> form-urlencoded)
    const data = Object.keys(jsonData)
      .map((key) => `${key}=${encodeURIComponent(jsonData[key])}`)
      .join("&");

    getAxiosInstance()
      .post("/admin/screens", data, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
      .then((res) => {
        // Validating form
        setIsLoading(false);
        if (res.data.status === "success") {
          // console.log(res.data);
          setTotalScreens(res.data.totalCount);
          setScreens(res.data.result);
        } else if (res.data.status === "error")
          Toast.fire({ icon: "error", title: res.data.message });
        else Toast.fire({ icon: "error", title: "Cannot process request" });
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getScreens();

    const intervalId = setInterval(() => {
      //assign interval to a variable to clear it.
      console.log("CALLING SCREEN");
      getScreens(true); // Use latest values from ref
    }, 15 * 1000); // Every 15 seconds

    return () => clearInterval(intervalId); //This is important
  }, [
    limit,
    pageNumber,
    searchFilter,
    country,
    state,
    city,
    building,
    floor,
    countryOpt,
    stateOpt,
    cityOpt,
    buildingOpt,
    floorOpt,
  ]);

  const changePage = ({ selected }) => setPageNumber(selected);

  const deleteScreen = (id) => {
    Swal.fire({
      icon: "warning",
      title: "Are you sure?",
      html: "<h5>This screen will be deleted?</h5>",
      showCancelButton: true,
      confirmButtonText: `Delete`,
      confirmButtonColor: "#D14343",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        const params = { id: id };

        // converting (json --> form-urlencoded)
        const data = Object.keys(params)
          .map((key) => `${key}=${encodeURIComponent(params[key])}`)
          .join("&");

        getAxiosInstance()
          .post("/admin/delete-screen", data, {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          })
          .then((res) => {
            // Validating form
            setIsLoading(false);
            if (res.data.status === "success") {
              Toast.fire({
                icon: "success",
                title: "Successfully deleted screen",
              });
              getScreens();
            } else {
              console.log(res.data);
              Toast.fire({ icon: "error", title: "Unable to delete screen" });
            }
          })
          .catch((err) => {
            Toast.fire({ icon: "error", title: "Unexpected Error" });
            setIsLoading(false);
            console.log(err);
          });
      }
    });
  };

  useEffect(() => {
    getAxiosInstance()
      .get("/admin/me")
      .then((res) => {
        if (res.data.result.user_type !== "admin") {
          setNotAdmin(true);
          setCountry(res.data.result.location.country);
          setState(res.data.result.location.state);
          setCity(res.data.result.location.city);
          setBuilding(res.data.result.location.building);
          setFloor(res.data.result.location.floor);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-3">
              <div className="col-sm-6">
                <h1 className="m-0">{type ? "Select Screen" : "Screen"}</h1>
              </div>
              <div className="col-sm-6">
                <div className="float-right">
                  {(selectionType === "all" || selectedScreen.length > 0) && (
                    <AddScheduleCampaign
                      type={"add"}
                      getAxiosInstance={getAxiosInstance}
                      Toast={Toast}
                      selectedScreen={selectedScreen}
                      selectionType={selectionType}
                      schedule={type === "schedule"}
                      screens={screens}
                      media={media}
                      filter={{
                        search: searchFilter,
                        country: getIdList(country),
                        state: getIdList(state),
                        city: getIdList(city),
                        building: getIdList(building),
                        floor: getIdList(floor),
                        screenId:
                          selectionType === "all"
                            ? screens.map((e) => e._id)
                            : selectedScreen,
                      }}
                    />
                  )}
                  {!type && (
                    <AddScreenCsv
                      getAxiosInstance={getAxiosInstance}
                      Toast={Toast}
                      getScreens={getScreens}
                    />
                  )}
                  {!type && (
                    <AddUpdateScreen
                      type={"add"}
                      getAxiosInstance={getAxiosInstance}
                      Toast={Toast}
                      getScreens={getScreens}
                      getFloors={getFloors}
                      getBuildings={getBuildings}
                      getCities={getCities}
                      getStates={getStates}
                      getCountries={getCountries}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-2">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  onClick={() => {
                    setCountryOpt("");
                    setStateOpt("");
                    setCityOpt("");
                    setBuildingOPt("");
                    setFloorOpt("");
                    setSearchFilter("");
                    setPageNumber(0);
                  }}
                  title="Reset all filters"
                >
                  <i className="fas fa-redo"></i> Reset Filters
                </button>
              </div>
              <div className="col-md-2">
                {/* <AsyncSelect
                  defaultOptions
                  cacheOption
                  isMulti
                  placeholder="Countries"
                  value={country}
                  getOptionLabel={(e) => `${e.name} (${e.code})`}
                  getOptionValue={(e) => e._id}
                  loadOptions={fetchCountryData}
                  onInputChange={setInputCountry}
                  isDisabled={notAdmin}
                  onChange={(e) => {
                    setCountry(e);
                    setState([]);
                    setCity([]);
                    setBuilding([]);
                    setFloor([]);
                  }}
                /> */}
                <select
                  value={countryOpt}
                  onChange={(e) => {
                    setCountryOpt(e.target.value);
                    setStateOpt("");
                    setCityOpt("");
                    setBuildingOPt("");
                    setFloorOpt("");
                  }}
                >
                  <option value="">Select Country---</option>
                  {allCountry.map((opt, i) => (
                    <option key={i} value={opt._id}>
                      {opt.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-2">
                {/* <AsyncSelect
                  defaultOptions
                  cacheOption
                  isMulti
                  placeholder="States"
                  value={state}
                  getOptionLabel={(e) => e.name}
                  getOptionValue={(e) => e._id}
                  loadOptions={fetchStateData}
                  onInputChange={setInputState}
                  isDisabled={notAdmin}
                  onChange={(e) => {
                    setState(e);
                    setCity([]);
                    setBuilding([]);
                    setFloor([]);
                  }}
                /> */}

                <select
                  value={stateOpt}
                  onChange={(e) => {
                    setStateOpt(e.target.value);
                    setCityOpt("");
                    setBuildingOPt("");
                    setFloorOpt("");
                  }}
                  disabled={!countryOpt}
                >
                  <option value="">Select State---</option>
                  {allState.map((opt, i) => (
                    <option key={i} value={opt._id}>
                      {opt.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-2">
                {/* <AsyncSelect
                  defaultOptions
                  cacheOption
                  isMulti
                  placeholder="Cities"
                  value={city}
                  getOptionLabel={(e) => e.name}
                  getOptionValue={(e) => e._id}
                  loadOptions={fetchCityData}
                  onInputChange={setInputCity}
                  isDisabled={notAdmin}
                  onChange={(e) => {
                    setCity(e);
                    setBuilding([]);
                    setFloor([]);
                  }}
                /> */}

                <select
                  value={cityOpt}
                  onChange={(e) => {
                    setCityOpt(e.target.value);
                    setBuildingOPt("");
                    setFloorOpt("");
                  }}
                  disabled={!stateOpt}
                >
                  <option value="">Select City---</option>
                  {allCity?.map((opt, i) => (
                    <option key={i} value={opt._id}>
                      {opt.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-2">
                {/* <AsyncSelect
                  defaultOptions
                  cacheOption
                  isMulti
                  placeholder="Buildings"
                  value={building}
                  getOptionLabel={(e) => e.name}
                  getOptionValue={(e) => e._id}
                  loadOptions={fetchBuildingData}
                  onInputChange={setInputBuilding}
                  isDisabled={notAdmin}
                  onChange={(e) => {
                    setBuilding(e);
                    setFloor([]);
                  }}
                /> */}
                <select
                  value={buildingOpt}
                  onChange={(e) => {
                    setBuildingOPt(e.target.value);
                    setFloorOpt("");
                  }}
                  disabled={!cityOpt}
                >
                  <option value="">Select Building---</option>
                  {allBuilding.map((opt, i) => (
                    <option key={i} value={opt._id}>
                      {opt.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-2">
                {/* <AsyncSelect
                  defaultOptions
                  cacheOption
                  isMulti
                  placeholder="Floors"
                  value={floor}
                  getOptionLabel={(e) => e.name}
                  getOptionValue={(e) => e._id}
                  loadOptions={fetchFloorData}
                  onInputChange={setInputFloor}
                  isDisabled={notAdmin}
                  onChange={setFloor}
                /> */}
                <select
                  value={floorOpt}
                  onChange={(e) => setFloorOpt(e.target.value)}
                  disabled={!buildingOpt}
                >
                  <option value="">Select Floor---</option>
                  {allFloor.map((opt, i) => (
                    <option key={i} value={opt._id}>
                      {opt.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row justify-content-center mt-3">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div class="card-tools">
                      <div
                        className="input-group input-group-sm"
                        style={{ width: 250 }}
                      >
                        <input
                          type="text"
                          name="table_search"
                          className="form-control float-right"
                          placeholder="Search"
                          value={searchFilter}
                          onChange={(e) => setSearchFilter(e.target.value)}
                        />
                        <div className="input-group-append">
                          <button
                            type="submit"
                            className="btn btn-default"
                            onClick={() => getScreens()}
                          >
                            <i className="fas fa-search" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th style={{ width: 100 }}>ID</th>
                          <th>Screen ID</th>
                          <th>Floor</th>
                          <th>Building</th>
                          <th>City</th>
                          <th>State</th>
                          <th>Country</th>
                          <th>Status</th>
                          {!type && <th style={{ width: 40 }}>Action</th>}
                          {type && (
                            <th style={{ width: 40 }}>
                              <input
                                type="checkbox"
                                id="selectAll"
                                checked={
                                  totalScreens !== 0 &&
                                  (selectionType === "all" ||
                                    selectedScreen.length === totalScreens)
                                }
                                ref={(el) =>
                                  el &&
                                  (el.indeterminate =
                                    selectionType !== "all" &&
                                    selectedScreen.length !== totalScreens &&
                                    selectedScreen.length > 0)
                                }
                                // onChange={() => {
                                //   if (totalScreens === 0)
                                //     return Toast.fire({
                                //       icon: "error",
                                //       title: "Add screen to select.",
                                //     });
                                //   if (
                                //     selectionType === "all" ||
                                //     selectedScreen.length > 0
                                //   )
                                //     setSelectionType("");
                                //   else setSelectionType("all");
                                //   setSelectedScreen([]);
                                // }}
                                onChange={() => {
                                  if (totalScreens === 0)
                                    return Toast.fire({
                                      icon: "error",
                                      title: "Add screen to select.",
                                    });
                                  if (
                                    selectionType === "all" ||
                                    selectedScreen.length > 0
                                  )
                                    setSelectionType("");
                                  else setSelectionType("all");
                                  // setSelectedScreen(screens.map((e) => e._id));
                                  setSelectedScreen([]);
                                  // console.log("zzzzzzzzzzz");
                                }}
                              />
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading && (
                          <tr style={{ textAlign: "center" }}>
                            <td colSpan={11}>Loading Screens ...</td>
                          </tr>
                        )}
                        {!isLoading && totalScreens === 0 && (
                          <tr style={{ textAlign: "center" }}>
                            <td colSpan={11}>No Screens Found</td>
                          </tr>
                        )}
                        {screens?.map((screen, i) => (
                          <tr key={i}>
                            <td>{screen.uid || screen.id}</td>
                            <td>{screen.name}</td>
                            <td>{screen.floor?.name}</td>
                            <td>{screen.building?.name}</td>
                            <td>{screen.city?.name}</td>
                            <td>{screen.state?.name}</td>
                            <td>{screen.country?.name}</td>
                            <td className="text-center">
                              <i
                                className={`fas fa-circle text-${
                                  screen.status === 0 ? "danger" : "success"
                                }`}
                              ></i>
                            </td>
                            {!type && (
                              <td>
                                <div style={{ display: "flex" }}>
                                  <AddUpdateScreen
                                    type={"update"}
                                    getAxiosInstance={getAxiosInstance}
                                    Toast={Toast}
                                    getScreens={getScreens}
                                    getFloors={getFloors}
                                    getBuildings={getBuildings}
                                    getCities={getCities}
                                    getStates={getStates}
                                    getCountries={getCountries}
                                    screenUp={screen}
                                  />
                                  <button
                                    type="button"
                                    class="btn btn-danger btn-sm ml-1"
                                    title="Delete"
                                    onClick={() => deleteScreen(screen._id)}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </div>
                              </td>
                            )}
                            {type && (
                              <td>
                                <input
                                  type="checkbox"
                                  checked={
                                    selectionType === "all" ||
                                    selectedScreen.find((s) => s === screen._id)
                                      ? true
                                      : false
                                  }
                                  onChange={() => {
                                    if (selectionType === "all") {
                                      setSelectionType("");
                                      setSelectedScreen([]);
                                    } else if (
                                      selectedScreen.find(
                                        (s) => s === screen._id
                                      )
                                    ) {
                                      setSelectedScreen((oldScreens) =>
                                        oldScreens.filter(
                                          (s) => s !== screen._id
                                        )
                                      );
                                    } else
                                      setSelectedScreen([
                                        ...selectedScreen,
                                        screen._id,
                                      ]);
                                  }}
                                />
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="card-footer clearfix">
                    {totalScreens > limit ? (
                      <ReactPaginate
                        previousLabel={"Â«"}
                        nextLabel={"Â»"}
                        pageCount={Math.ceil(totalScreens / limit)}
                        onPageChange={changePage}
                        containerClassName={
                          "pagination pagination-sm m-0 float-right"
                        }
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        // previousClassName={"previous"}
                        previousLinkClassName={"page-link"}
                        // nextClassName={"next"}
                        nextLinkClassName={"page-link"}
                        disabledClassName={"disabled"}
                        activeClassName={"active"}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
